import {Brick, registerBrick, Auth, User, CloudObject} from 'olympe';

export default class FilterCustom extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} list
     * @param {function()} forwardEvent
     * @param {function(boolean)} setIsItemPresent
     */
    update ($, [list], [forwardEvent, setIsItemPresent]) {
        const email = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
        const isOwner = list.some(item => item === email);
        setIsItemPresent(isOwner);

        // Trigger the output Control Flow
        forwardEvent();
    }
}

registerBrick('018e2c43fe7f3c149717', FilterCustom);
